import { makeStyles } from '@material-ui/core/styles';

const adsetStyles = makeStyles((theme) => ({
  root: {
    position: 'relative'
  },
  isFixed: {
    position: 'fixed',
    width: 'auto',
    [theme.breakpoints.up('md')]: {
      top: '130px',
    }
  }
}));

export default adsetStyles;
